import { RECEIVED_INVOICE_PUBLIC_SUBMODULE } from '@kros-sk/document-viewer/public-document-view';
import { DocumentTypes } from '@kros-sk/models';

export const PUBLIC_DOCUMENT_SUBMODULES: Partial<Record<DocumentTypes, string>> = {
  [DocumentTypes.ReceivedInvoice]: RECEIVED_INVOICE_PUBLIC_SUBMODULE,
  [DocumentTypes.Invoice]: RECEIVED_INVOICE_PUBLIC_SUBMODULE,
};
